<!--
    @不参与审核的领导首页-项目跟踪-步骤流程
-->
<template>
	<div class="leader_step">
		<div class="item" :class="classFn(item)" v-for="(item,i) in data" :key="i">
			<div class="line left_line"></div>
			<span class="my_icon el-icon-check" :title="processHandle(item)" v-if="processHandle(item)=='pass'"></span>
			<span class="my_icon" :title="processHandle(item)" v-else-if="processHandle(item)=='ing'">{{i+1}}</span>
			<span class="my_icon el-icon-arrow-right" v-else></span>
			<em>{{item.name}}</em>
			<div class="line right_line"></div>
		</div>
	</div>
</template>

<script>
export default {
	props:{
		data:{
			type:Array,
			default:function(){
				return [];
			}
		},
		buyprojectState:{
			type:Number,
			default:0
		}
	},
	data(){
		return{}
	},
	methods:{
		processHandle(item){
			// let temp=this.getMax();
			// if(item.completeState && (item.projectState<temp)){
			// 	return 'pass';
			// }else if(item.completeState && (item.projectState==temp)){
			// 	return 'ing';
			// }else{
			// 	return null;
			// }
			if(item.completeState){
				if(item.completeState&&item.currentNode){
					return 'ing';
				}
				return 'pass';
			}
		},
		classFn(item){
			// let temp=this.getMax();
			// if(item.completeState && (item.projectState<temp)){
			// 	return 'step_pass';
			// }else if(item.completeState && (item.projectState==temp)){
			// 	return 'step_ing';
			// }else{
			// 	return null;
			// }
			if(item.completeState){
				if(item.completeState&&item.currentNode){
					return 'step_ing';
				}
				return 'step_pass';
			}
		},
		// 获取completeState为ture的projectState最大值
		getMax(){
			let max = this.data[0].projectState;
			for (let i = 0; i < this.data.length-1; i++) {
				if(this.data[i+1].completeState){
					max = Number(max) < Number(this.data[i+1].projectState) ? Number(this.data[i+1].projectState) : Number(max);
				}
			}
			return max;
		}
	}
}
</script>

<style lang="less" scoped>
.leader_step{
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
	position: relative;
	.item{
		width: 100px;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;
		z-index: 1;
		.my_icon{
			width: 24px;
			height: 24px;
			border: 1px solid #CCCCCC;
			border-radius: 50%;
			text-align: center;
			line-height: 22px;
		}
		em{
			font-style: normal;
			margin-top: 8px;
			font-size: 14px;
		}
		.line{
			// width: 36px;
			width: calc(50% - 12px);
			height: 1px;
			background: #CCCCCC;
			position: absolute;
			top: 12px;
			z-index: 10;
		}
		.left_line{
			left: 0px;
		}
		.right_line{
			right: 0px;
		}
		&:nth-child(1){
			.left_line{
				display: none;
			}
		}
		&:last-child{
			.right_line{
				display: none;
			}
		}
	}
	.step_pass{
		.my_icon{
			border-color: #1890FF;
			color: #1890FF;
		}
		.line{
			background: #1890FF;
			z-index: 20;
		}
	}
	.step_ing{
		.my_icon{
			border-color: #1890FF;
			background: #1890FF;
			color: #ffffff;
		}
		.line{
			background: #1890FF;
			z-index: 20;
		}
	}
}
</style>
